import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { createElement as _createElement } from "react";
import { trackClientEvent } from "@faire/web-api--source/trackClientEvent";
import React from "react";
import { Button } from "../../../slate/Button/Button";
export var BuilderButton = function(_param) {
    var textContent = _param.textContent, eventKeyOnClick = _param.eventKeyOnClick, eventParams = _param.eventParams, attributes = _param.attributes, openInNewTab = _param.openInNewTab, props = _object_without_properties(_param, [
        "textContent",
        "eventKeyOnClick",
        "eventParams",
        "attributes",
        "openInNewTab"
    ]);
    return /*#__PURE__*/ _createElement(Button, _object_spread_props(_object_spread({}, props), {
        style: attributes.style,
        className: attributes.className,
        key: attributes["key"],
        "builder-id": attributes["builder-id"],
        target: openInNewTab ? "_blank" : "_self",
        onClick: eventKeyOnClick ? function() {
            trackClientEvent({
                eventKey: eventKeyOnClick,
                parameters: eventParams === null || eventParams === void 0 ? void 0 : eventParams.map(function(param) {
                    var _$param = param.param;
                    return _$param;
                })
            });
        } : undefined
    }), textContent);
};
